<template>
  <div>
    <v-layout wrap justify-center pt-10 pb-16 style="background-color:#3d673a">
      <v-flex xs12 sm12 md12 lg11 xl12 class="hidden-sm-and-down">
        <v-layout wrap justify-center px-lg-10 mx-lg-16  mx-md-10>
          <v-flex xs2 sm2 md3 lg3>
            <v-layout wrap justify-center>
              <v-flex xs12 style="position: relative;">
                <v-img src="../assets/Images/icon1.png" max-height="170" max-width="170" class="mb-n5 ml-16" style="z-index: 1;"></v-img>
                <v-card height="100px" flat class="pa-2 text-center rounded-xl" style="background-color: #e47926; color: white;">
                  <div class="d-flex align-center justify-center" style="height: 100%;">
                    <div style="font-size:30px;font-weight:bold">Here’s why</div>
                  </div>
                </v-card>
              </v-flex>
              
              <v-flex xs12 pt-4>
                <v-card  @click="dialog1 = true" flat height="440px" class="pa-4 text-center rounded-xl"
                  style="background-color: #ffc93c; color: white;">
                  <v-img src="../assets/Images/Expert-Led Learning.png" max-height="170" max-width="170"
                    class="mx-auto mt-5"></v-img>
                  <v-flex pt-8 text-left style="font-size:23px; color:#3d673a;font-family:poppinsbold;font-weight:bold">
                    Expert-Led<br> Learning
                  </v-flex>
                  <v-flex xs12 pt-lg-14 pt-md-16 class="d-flex justify-end">
                    <v-icon color="#873e23" size="60">mdi-chevron-down-circle</v-icon>
                    <!-- <v-img max-height="40px" max-width="40px" src="../assets/Images/arrowicon.jpg"></v-img> -->
                  </v-flex>
                </v-card>

              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs2 sm2 md3 lg3 pl-4 pt-8>
            <v-layout wrap justify-center>
              <v-flex xs12 text-left>
                <v-card  @click="dialog2 = true" flat height="290px" class="pa-4 text-center rounded-xl"
                  style="background-color: #ffc93c; color: #3d673a;font-size:20px;font-family:poppinsbold">
                  <div class=" font-weight-bold text-left" >Hands-On Field Experience</div>
                  <v-flex xs12 class="d-flex justify-left">
                    <v-img  src="../assets/Images/Hands-On Field Experience1.png" max-height="120" max-width="120"
                      class="mt-2"></v-img>
                  </v-flex>
                  <v-flex xs12 pt-0 class="d-flex justify-end">
                    <v-icon color="#873e23" size="60">mdi-chevron-down-circle</v-icon>
                  </v-flex>
                </v-card>
              </v-flex>
              <v-flex xs12 text-left pt-3>
                <v-card flat @click="dialog3 = true" height="290px" class="pa-4 text-center rounded-xl"
                  style="background-color: #ffc93c; color: #3d673a;font-size:20px;font-family:poppinsbold">
                  <div class=" font-weight-bold text-left">Integrated Approach to Conservation</div>
                  <v-flex xs12 class="d-flex justify-left">
                    <v-img  src="../assets/Images/Integrated Approach to Conservation.png" max-height="120" max-width="120"
                      class="mt-1"></v-img>
                  </v-flex>
                  <v-flex xs12 pt-lg-4 pt-md-0 class="d-flex justify-end">
                    <v-icon color="#873e23" size="60">mdi-chevron-down-circle</v-icon>
                  </v-flex>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs2 sm2 md3 lg3 pl-4 pt-8>
            <v-layout wrap justify-center>
              <v-flex xs12 text-left>
                <v-card @click="dialog4 = true" flat height="290px" class="pa-4 text-center rounded-xl"
                  style="background-color: #ffc93c; color: #3d673a;font-size:20px;font-family:poppinsbold">
                  <div class=" font-weight-bold text-left">Direct Impact on Conservation</div>
                  <v-flex xs12 class="d-flex justify-left">
                    <v-img  src="../assets/Images/Direct Impact on Conservation.png" max-height="120" max-width="120"
                      class="mt-2"></v-img>
                  </v-flex>
                  <v-flex xs12 class="d-flex justify-end">
                    <v-icon color="#873e23" size="60">mdi-chevron-down-circle</v-icon>
                  </v-flex>
                </v-card>
              </v-flex>
              <v-flex xs12 text-left pt-3>
                <v-card flat @click="dialog5= true" height="290px" class="pa-4 text-center rounded-xl"
                  style="background-color: #ffc93c; color: #3d673a;font-size:20px;font-family:poppinsbold">
                  <div class=" font-weight-bold text-left">Career Readiness</div>
                  <v-flex xs12 class="d-flex justify-left">
                    <v-img  src="../assets/Images/Career Readiness.png" max-height="120" max-width="120"
                      class="mt-9"></v-img>
                  </v-flex>
                  <v-flex xs12 pt-lg-4 pt-md-7 class="d-flex justify-end">
                    <v-icon color="#873e23" size="60">mdi-chevron-down-circle</v-icon>
                  </v-flex>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs2 sm2 md3 lg3 pl-4 pt-8>
            <v-layout wrap justify-start>
              <v-flex xs12>
                <v-card flat @click="dialog6= true" height="250px" class="pa-4 text-center rounded-xl"
                  style="background-color: #ffc93c; color: #3d673a;font-size:20px;font-family:poppinsbold">
                  <div class="font-weight-bold text-left">Eligibility Criteria</div>
                  <v-flex xs12 class="d-flex justify-left">
                    <v-img src="../assets/Images/Eligibility Criteria.png" max-height="120" max-width="120"
                      class="mt-2"></v-img>
                  </v-flex>
                  <v-flex xs12 class="d-flex justify-end">
                    <v-icon color="#873e23" size="60">mdi-chevron-down-circle</v-icon>
                  </v-flex>

                </v-card>
              </v-flex>
              <v-flex xs12 pt-3>
                <v-card 
                  flat
                  height="330px"
                  class="pa-4 text-center rounded-xl bacimg"
                  style="
                    background-size: cover;
                    background-position: center;
                    background-repeat: no-repeat;
                    color: white;
                  "
                >
                <v-flex style="position: absolute; bottom: 16px;  width: 90%; text-align: center;">
                  <a href="https://www.bvuniversity.edu.in/admission-enquiry" target="_blank" rel="noopener noreferrer">
                    <v-btn color="#344E41" class="custom-btn" style="background-color: #F9C641;" rounded>
                        <span style="color: #3d673a; font-family: poppinsbold; font-size: 15px;">
                            APPLY NOW
                        </span>
                    </v-btn>
                </a>
                 </v-flex>
                </v-card>
              </v-flex>
              
            </v-layout>
          </v-flex>
          <!-- sm and down -->
           
        </v-layout>
      </v-flex>

      <!-- in small screen -->
       <v-flex xs12 sm12 md12 xl12 class="hidden-md-and-up">
        <v-layout wrap justify-center >
        
            <v-flex xs11>
              <v-layout wrap justify-center>
                <v-flex xs12 style="position: relative;">
                  <v-img src="../assets/Images/icon1.png" max-height="160" max-width="160" class="mb-n5 ml-16 "
                    style="z-index: 1;"></v-img>
                  <v-card   flat class="pa-4 text-center rounded-xl" style="background-color: #e47926; color: white;">
                    <div style="font-size:28px;font-weight:bold">Here’s why</div>
                    
                  </v-card>
                </v-flex>
                <v-flex xs12 pt-3>
                  <v-card  @click="dialog1 = true" flat height="280px" class="pa-4 text-center rounded-xl"
                    style="background-color: #ffc93c; color: white;">
                    <v-img src="../assets/Images/Expert-Led Learning.png" max-height="150" max-width="150"
                      class="mx-auto mt-2"></v-img>
                    <v-flex pt-3 text-center style="font-size:20px; color:#3d673a;font-family:poppinsbold">
                      Expert-Led Learning
                    </v-flex>
                    <v-flex xs12 class="d-flex justify-end">
                      <v-icon color="#873e23" size="60">mdi-chevron-down-circle</v-icon>
                    </v-flex>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout wrap justify-center pt-4>
                <v-flex xs12>
                  <v-card  @click="dialog2 = true" flat height="310px" class="pa-4 text-center rounded-xl"
                    style="background-color: #ffc93c; color: green;font-size:20px">
                     <v-img src="../assets/Images/Hands-On Field Experience1.png" max-height="150" max-width="150"
                      class="mx-auto mt-2"></v-img>
                    <v-flex pt-3 text-center style="font-size:20px; color:#3d673a;font-family:poppinsbold">Hands-On Field Experience</v-flex>
                 
                     <v-flex xs12 class="d-flex justify-end">
                      <v-icon color="#873e23" size="60">mdi-chevron-down-circle</v-icon>
                    </v-flex>
                  </v-card>
                </v-flex>
                <v-flex xs12 text-center pt-3>
                  <v-card flat @click="dialog3 = true" height="330px" class="pa-4 text-center rounded-xl"
                    style="background-color: #ffc93c; color: green;font-size:20px">
                    <v-img src="../assets/Images/Integrated Approach to Conservation.png" max-height="150" max-width="150"
                    class="mx-auto mt-2"></v-img>
                    <v-flex pt-3 text-center style="font-size:20px; color:green;font-family:poppinsbold">Integrated Approach to Conservation</v-flex>
                    
                     <v-flex xs12 class="d-flex justify-end">
                      <v-icon color="#873e23" size="60">mdi-chevron-down-circle</v-icon>
                    </v-flex>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout wrap justify-center pt-4>
                <v-flex xs12 text-center>
                  <v-card @click="dialog4 = true" flat height="320px" class="pa-4 text-center rounded-xl"
                    style="background-color: #ffc93c; color: green;font-size:20px">
                    <v-img src="../assets/Images/Direct Impact on Conservation.png" max-height="150" max-width="150"
                    class="mx-auto mt-2"></v-img>
                    <v-flex pt-3 text-center style="font-size:20px; color:green;font-family:poppinsbold">Direct Impact on Conservation</v-flex>
                    <v-flex xs12 class="d-flex justify-left">
                     
                    </v-flex>
                    <v-flex xs12 class="d-flex justify-end">
                      <v-icon color="#873e23" size="60">mdi-chevron-down-circle</v-icon>
                    </v-flex>
                  </v-card>
                </v-flex>
                <v-flex xs12 text-center pt-3>
                  <v-card flat @click="dialog5= true" height="280px" class="pa-4 text-center rounded-xl"
                    style="background-color: #ffc93c; color: green;font-size:20px">
                    <v-img src="../assets/Images/Career Readiness.png" max-height="150" max-width="150"
                    class="mx-auto mt-2"></v-img>
                        <v-flex pt-3 text-center style="font-size:20px; color:green;font-family:poppinsbold">Career Readiness</v-flex>
                    <v-flex xs12 class="d-flex justify-left">
                      
                    </v-flex>
                     <v-flex xs12 class="d-flex justify-end">
                      <v-icon color="#873e23" size="60">mdi-chevron-down-circle</v-icon>
                    </v-flex>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout wrap justify-center pt-4>
                <v-flex xs12>
                  <v-card flat @click="dialog6= true" height="280px" class="pa-4 text-center rounded-xl"
                    style="background-color: #ffc93c; color: green;font-size:20px">
                    <v-img src="../assets/Images/Eligibility Criteria.png" max-height="150" max-width="150"
                    class="mx-auto mt-2"></v-img>
                    <v-flex pt-3 text-center style="font-size:20px; color:green;font-family:poppinsbold">Eligibility Criteria</v-flex>
                    <v-flex xs12 class="d-flex justify-left">
                     
                    </v-flex>
                     <v-flex xs12 class="d-flex justify-end">
                      <v-icon color="#873e23" size="60">mdi-chevron-down-circle</v-icon>
                    </v-flex>
  
                  </v-card>
                </v-flex>
                <v-flex xs12 pt-3>
                  <v-card 
                    flat
                    height="280px"
                    class="pa-4 text-center rounded-xl bacimg"
                    style="
                      background-size:cover;
                      background-position: center;
                      background-repeat: no-repeat;
                      color: white;
                    "
                  >
                  <v-flex style="position: absolute; bottom: 16px;  width: 90%; text-align: center;">
                    <a href="https://www.bvuniversity.edu.in/admission-enquiry" target="_blank" rel="noopener noreferrer">
                      <v-btn color="#344E41" class="custom-btn" style="background-color: #F9C641;" rounded>
                          <span style="color: #3d673a; font-family: poppinsbold; font-size: 15px;">
                              APPLY NOW
                          </span>
                      </v-btn>
                  </a>
                   </v-flex>
                  </v-card>
                </v-flex>
                
              </v-layout>
            </v-flex>
          
          </v-layout>
       </v-flex>
    </v-layout>

      <!-- Dialog1 Box -->
      <v-dialog persistent v-model="dialog1" max-width="600px">
        <v-card>
          <v-layout wrap>
            <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
              <v-layout wrap>
                <v-flex xs6 align-self-center text-left>
                  <span class="poppinsbold" style="color: #ffffff; font-size: 20px">
                    Expert-Led Learning
                  </span>
                </v-flex>
                <v-flex xs6 align-self-center text-right>
                  <v-btn icon color="white" text @click="dialog1 = false">
                    <v-icon color="#ffffff">mdi-close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
     
            <v-flex xs12>
              <v-layout wrap px-5 pt-3 pb-4>
                <v-flex xs12 align-self-center text-left>
                  <span class="poppinsregular" style="color: #000; font-size: 16px">•	The program is co-designed and co-taught by WTI’s experienced conservationists and BVIEER’s expert faculty, ensuring a balance of academic rigor and practical field insights.
                 <br>   •	Learn directly from professionals working on the frontlines of wildlife conservation in India.
                    
                  </span>
                </v-flex>
  
                <v-flex xs12 align-self-center text-right pt-3>
                  <v-btn @click="dialog1 = false" color="#005f32">
                    <span class="poppinsbold" style="color: white">  Close </span>
                  </v-btn></v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>

       <!-- Dialog2 Box -->
       <v-dialog persistent v-model="dialog2" max-width="600px">
        <v-card>
          <v-layout wrap>
            <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
              <v-layout wrap>
                <v-flex xs6 align-self-center text-left>
                  <span class="poppinsbold" style="color: #ffffff; font-size: 20px">
                    Hands-On Field Experience
                  </span>
                </v-flex>
                <v-flex xs6 align-self-center text-right>
                  <v-btn icon color="white" text @click="dialog2 = false">
                    <v-icon color="#ffffff">mdi-close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
     
            <v-flex xs12>
              <v-layout wrap px-5 pt-3 pb-4>
                <v-flex xs12 align-self-center text-left>
                  <span class="poppinsregular" style="color: #000; font-size: 16px">•	Students intern with WTI on real-world conservation projects across diverse landscapes—wetlands, forests, grasslands, and coasts—gaining exposure to species recovery, habitat restoration, and human-wildlife conflict mitigation.
                  <br>  •	Field training modules allow students to actively participate in conservation efforts, making the learning experience immersive and impactful.
                    
                    
                  </span>
                </v-flex>
  
                <v-flex xs12 align-self-center text-right pt-3>
                  <v-btn @click="dialog2 = false" color="#005f32">
                    <span class="poppinsbold" style="color: white">  Close </span>
                  </v-btn></v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
       <!-- Dialog3 Box -->
       <v-dialog persistent v-model="dialog3" max-width="600px">
        <v-card>
          <v-layout wrap>
            <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
              <v-layout wrap>
                <v-flex xs10 align-self-center text-left>
                  <span class="poppinsbold" style="color: #ffffff; font-size: 20px">
                    Integrated Approach to Conservation
                  </span>
                </v-flex>
                <v-flex xs2 align-self-center text-right>
                  <v-btn icon color="white" text @click="dialog3 = false">
                    <v-icon color="#ffffff">mdi-close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
     
            <v-flex xs12>
              <v-layout wrap px-5 pt-3 pb-4>
                <v-flex xs12 align-self-center text-left>
                  <span class="poppinsregular" style="color: #000; font-size: 16px">•	Unlike conventional programs, this course blends ecological, sociological, legal, and management perspectives.
                 <br>  •	Students gain a holistic understanding of wildlife conservation, addressing challenges at the intersection of environment, development, and policy.
                    </span>
                </v-flex>
  
                <v-flex xs12 align-self-center text-right pt-3>
                  <v-btn @click="dialog3 = false" color="#005f32">
                    <span class="poppinsbold" style="color: white">  Close </span>
                  </v-btn></v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
       <!-- Dialog4 Box -->
       <v-dialog persistent v-model="dialog4" max-width="600px">
        <v-card>
          <v-layout wrap>
            <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
              <v-layout wrap>
                <v-flex xs6 align-self-center text-left>
                  <span class="poppinsbold" style="color: #ffffff; font-size: 20px">
                    Direct Impact on Conservation
                  </span>
                </v-flex>
                <v-flex xs6 align-self-center text-right>
                  <v-btn icon color="white" text @click="dialog4 = false">
                    <v-icon color="#ffffff">mdi-close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
     
            <v-flex xs12>
              <v-layout wrap px-5 pt-3 pb-4>
                <v-flex xs12 align-self-center text-left>
                  <span class="poppinsregular" style="color: #000; font-size: 16px">•	By working alongside WTI’s teams, students contribute to projects with measurable outcomes, including species rescue, community engagement, and biodiversity monitoring.
                  <br>  •	This unique program ensures students graduate not only with knowledge but also with real-world experience and networks in the conservation field.
                    </span>
                </v-flex>
  
                <v-flex xs12 align-self-center text-right pt-3>
                  <v-btn @click="dialog4 = false" color="#005f32">
                    <span class="poppinsbold" style="color: white">  Close </span>
                  </v-btn></v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
       <!-- Dialog5 Box -->
       <v-dialog persistent v-model="dialog5" max-width="600px">
        <v-card>
          <v-layout wrap>
            <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
              <v-layout wrap>
                <v-flex xs6 align-self-center text-left>
                  <span class="poppinsbold" style="color: #ffffff; font-size: 20px">
                    Career Readiness
                  </span>
                </v-flex>
                <v-flex xs6 align-self-center text-right>
                  <v-btn icon color="white" text @click="dialog5 = false">
                    <v-icon color="#ffffff">mdi-close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
     
            <v-flex xs12>
              <v-layout wrap px-5 pt-3 pb-4>
                <v-flex xs12 align-self-center text-left>
                  <span class="poppinsregular" style="color: #000; font-size: 16px">•	Graduates are equipped with skills that are directly applicable to professional roles in wildlife conservation, policy-making, environmental consulting, and NGOs.
                    
                    
                    
                  </span>
                </v-flex>
  
                <v-flex xs12 align-self-center text-right pt-3>
                  <v-btn @click="dialog5 = false" color="#005f32">
                    <span class="poppinsbold" style="color: white">  Close </span>
                  </v-btn></v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
       <!-- Dialog6 Box -->
       <v-dialog persistent v-model="dialog6" max-width="600px">
        <v-card>
          <v-layout wrap>
            <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
              <v-layout wrap>
                <v-flex xs6 align-self-center text-left>
                  <span class="poppinsbold" style="color: #ffffff; font-size: 20px">
                    Eligibility Criteria
                  </span>
                </v-flex>
                <v-flex xs6 align-self-center text-right>
                  <v-btn icon color="white" text @click="dialog6 = false">
                    <v-icon color="#ffffff">mdi-close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
     
            <v-flex xs12>
              <v-layout wrap px-5 pt-3 pb-4>
                <v-flex xs12 align-self-center text-left>
                  <span class="poppinsregular" style="color: #000; font-size: 16px;">
                    To qualify for the program, applicants must meet the following criteria:
                  </span>
                  <ul style="color: #000; font-size: 16px; padding-left: 20px;">
                    <li>
                      <strong>Educational Background:</strong> A Bachelor’s degree in:
                      <ul>
                        <li>Botany</li>
                        <li>Zoology</li>
                        <li>Chemistry</li>
                        <li>Physics</li>
                        <li>Statistics</li>
                        <li>Geography</li>
                        <li>Geology</li>
                        <li>Life Sciences</li>
                        <li>Environmental Sciences</li>
                        <li>Microbiology</li>
                        <li>Biotechnology</li>
                        <li>Fisheries</li>
                        <li>Marine Biology</li>
                        <li>Horticulture</li>
                        <li>Agriculture</li>
                        <li>Computer Science</li>
                        <li>Data Science</li>
                        <li>Veterinary Science</li>
                        <li>Health Sciences</li>
                      </ul>
                    </li>
                    <li>Any branch of Engineering</li>
                    <li>Any relevant Social Science subjects and Management Studies</li>

                    <li>
                      <strong>Minimum Academic Score</strong>
                      <ul>
                        <li>General Candidates: 50% aggregate in undergraduate studies</li>
                        <li>SC/ST/OBC Candidates: 45% aggregate.</li>
                        
                      </ul>
                    </li>

                    <li>
                      <strong>Work Experience</strong>
                      <ul>
                        <li>•	Candidates with degrees outside the listed fields must demonstrate a minimum of three years of experience in conservation work</li>
                        <li>•	A valid work experience certificate from the relevant organisation, signed and stamped by the Head of Institution, must be submitted.</li>
                        
                      </ul>
                    </li>
                    <li>
                      <strong>Duration:</strong> 2 years (Full Time)
                    </li>
                  </ul>
                  
                  
                </v-flex>
                
  
                <v-flex xs12 align-self-center text-right pt-3>
                  <v-btn @click="dialog6 = false" color="#005f32">
                    <span class="poppinsbold" style="color: white">  Close </span>
                  </v-btn></v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
      
    
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialog1: false, 
      dialog2: false, 
      dialog3: false, 
      dialog4: false, 
      dialog5: false, 
      dialog6: false, 
      

      cards: [
        { title: "Hands-On Field Experience", icon: "https://via.placeholder.com/50" },
        { title: "Direct Impact on Conservation", icon: "https://via.placeholder.com/50" },
        { title: "Eligibility Criteria", icon: "https://via.placeholder.com/50" },
        { title: "Expert-Led Learning", icon: "https://via.placeholder.com/50" },

      ],
    };
  },
};
</script>
<style>
.bacimg {
  background-image: url("./../assets/Images/Open Classroom.jpg");
}
</style>